// @ts-nocheck

export const localeCodes =  [
  "en",
  "es"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_common_46json_aa2098db",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_f20769ec",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_d045f652",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commerce_46json_e9bfd4b5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_4e4f3c5f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_presentation_46json_0930da2c",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_common_46json_e5a1d340",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_auth_46json_fd64ea86",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_public_46json_5c98da52",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_commerce_46json_86f3a995",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_dashboard_46json_27ee414d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_presentation_46json_b2bbce8b",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    language: "es",
    domains: [],
    defaultForDomains: []
  }
]

